// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"aa018366","508":"b8c01ba3","524":"dbf5e175","545":"d6c7c2a0","570":"b1456d9d","672":"cfdb3a72","702":"a0c28494","708":"1abfdfce"}[chunkId] + ".chunk.js";
};